import React from 'react'
import AddBankAccountModal from './AddBankAccountModal'
import { Modal } from 'react-bootstrap'
import BankAccountCreate from './BankAccountCreate'

const AddBankModal = (props) => {
  return (
  
   <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Bank Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <BankAccountCreate onHide={props.onHide} />
      </Modal.Body>
    </Modal>
  )
}

export default AddBankModal